import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";

export default function CountDownContainer(props) {
  const [lastTimeToHandle, setLastTimeToHandle] = useState("");
  const [lastTimeToHandleRemaining, setLastTimeToHandleRemaining] =
    useState("");
  const [timeToLeftInSec, setTimeToLeftInSec] = useState();
  let { value } = props;

  useEffect(() => {
    setLastTimeToHandle(value);
    var date = Date.parse(value);
    var currentDateInMs = Date.now();

    var timeToLeftInMs = date - currentDateInMs;

    var timeToLeftInSec = timeToLeftInMs / 1000;
    setTimeToLeftInSec(Math.floor(timeToLeftInSec));

    let interval = setInterval(() => {
      setTimeToLeftInSec((prev) => prev - 1);
      if (timeToLeftInSec <= 0) {
        clearInterval(interval);
      }
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    var timeToLeftInMin = Math.floor(timeToLeftInSec / 60);
    var timeToLeftInHour = Math.floor(timeToLeftInMin / 60);
    var timeToLeftInDay = Math.floor(timeToLeftInHour / 24);

    setLastTimeToHandleRemaining(
      timeToLeftInDay +
        ":" +
        (timeToLeftInHour % 24 < 10
          ? "0" + (timeToLeftInHour % 24)
          : timeToLeftInHour % 24) +
        ":" +
        (timeToLeftInMin % 60 < 10
          ? "0" + (timeToLeftInMin % 60)
          : timeToLeftInMin % 60) +
        ":" +
        (timeToLeftInSec % 60 < 10
          ? "0" + (timeToLeftInSec % 60)
          : timeToLeftInSec % 60)
    );
  }, [timeToLeftInSec]);

  return <div>{lastTimeToHandleRemaining}</div>;
}
CountDownContainer.propTypes = {
  value: PropTypes.string,
};
